<template>
  <div class="video-layout mb-20">
    <img
      class="hll-input-hint-img mb-20"
      :src="videoRecommendOptions.topImg"
      alt=""
    />
    <video
      class="video"
      controls
      :src="videoRecommendOptions.videoUrl"
      :poster="videoRecommendOptions.videoImg"
    ></video>
    <div class="title">{{ videoRecommendOptions.title }}</div>
    <p class="desc">{{ videoRecommendOptions.description }}</p>
    <div
      class="more-car"
      :style="{
        backgroundImage: 'url(' + videoRecommendOptions.buttonImg + ')'
      }"
      @click="changeVehicle"
    >
      {{ videoRecommendOptions.buttonText }}
    </div>
  </div>
</template>

<script>
export default {
  props: ["videoRecommendOptions"],
  methods: {
    changeVehicle() {
      this.$emit("changeVehicle", {
        typeName: "none",
        datas: {
          name: "",
          introduce: "",
          img: "",
          buttonImg: "",
          buttonText: ""
        },
        btnText: ""
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/assets/css/rpx.scss";
@import "./../common.scss";

.video-layout {
  margin: 0 rpx(30) 0 rpx(30);
  padding: rpx(20) rpx(40) rpx(40) rpx(40);
  overflow: hidden;
  background: #fff;
  border-radius: rpx(20);
  color: #383838;
  .hll-input-hint-img {
    margin-top: rpx(20);
    width: 100%;
  }
  .video {
    width: 100%;
  }
  .title {
    font-weight: bold;
    font-size: rpx(30);
    height: rpx(50);
    line-height: rpx(50);
  }
  .more-car {
    width: rpx(464);
    height: rpx(92);
    border-radius: rpx(46);
    line-height: rpx(92);
    background: url("~@/assets/img/more-car.png") no-repeat;
    background-size: 100% 100%;
    margin: rpx(20) auto;
    font-size: rpx(30);
    text-align: center;
    color: white;
    font-weight: bold;
  }
}
</style>
